import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import { isNull } from "../../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";

export default class AbstractDialogPlayerOptionsMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager
     * @param {ClickEaterFactory} clickEaterFactory
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._dialogPlayer;

        this._onDialogOptionsChangedBound = this._onDialogOptionsChanged.bind(this);
        this._onDialogOptionChosenBound = this._onDialogOptionChosen.bind(this);
        this._onDialogEndBound = this._onDialogEnd.bind(this);
    }

    destroy() {
        super.destroy();

        this._removeDialogPlayerListeners();
    }

    // ------------------------------------------
    //  Abstract functions (to override)
    // ------------------------------------------
    _handleDialogOptionsChanged() { }

    // ------------------------------------------
    //  Dialog listeners
    // ------------------------------------------
    _addDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;

        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    _removeDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;

        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    // ------------------------------------------
    //  Dialog handlers
    // ------------------------------------------
    _onDialogOptionsChanged(evt) {
        if (evt.params.contentPlayer !== this.getDialogPlayer()) {
            return;
        }

        this._handleDialogOptionsChanged();
    }

    _onDialogOptionChosen(evt) {
        if (evt.params.contentPlayer !== this.getDialogPlayer()) {
            return;
        }

        const data = evt.params.data;
        this._handleDialogOptionChosen(data.option);
    }

    _onDialogEnd(evt) {
        if (evt.params.contentPlayer !== this.getDialogPlayer()) {
            return;
        }

        this.setDialogPlayer(null);
    }

    // ------------------------------------------
    // Content delegates
    // ------------------------------------------

    getDialogPlayer() {
        return this._dialogPlayer;
    }

    setDialogPlayer(value) {
        if (!isNull(this._dialogPlayer)) {
            this._removeDialogPlayerListeners();
        }

        this._dialogPlayer = value;

        if (this._dialogPlayer !== null) {
            this._addDialogPlayerListeners();
        }
    }
}